/**
 * Settings button component.
 *
 * Cog icon button used to trigger the settings menu.
 */

import * as stylex from "@stylexjs/stylex";

import { cog } from "@animus/iconic-svg/icons/cog";
import { Button, Icon } from "@animus/primaris";
import { colors, radius } from "@animus/primaris/tokens.stylex";

const styles = stylex.create({
  base: {
    backgroundColor: colors.muted,
    ":hover": {
      backgroundColor: colors.accent,
    },
  },
  nav: {
    borderRadius: radius.lg,
  },
});

interface SettingsButtonProps {
  /** Style variant: "default" for header, "nav" for collapsed sidebar footer */
  variant?: "default" | "nav";
}

export function SettingsButton({ variant = "default" }: SettingsButtonProps) {
  const isNav = variant === "nav";

  return (
    <Button
      aria-label="Settings"
      size={isNav ? "default" : "sm"}
      startSymbol={<Icon size="sm" svg={cog} />}
      title={isNav ? "Settings" : undefined}
      type="button"
      variant="ghost"
      xstyle={[styles.base, isNav && styles.nav]}
    />
  );
}
